// EL LETRERO DE LA FASE, EN UN SITIO Y CON SU PRUEBA.
//
// Es la línea de arriba del modal de montar comida: la que dice qué toca ahora. Vivía suelta
// dentro del componente y el fallo que la trajo aquí no se puede ver en pantalla sin un
// alimento a medida -- hay que pillar los hidratos por encima del 80 % y todavía a seis
// gramos --, así que la regla se saca y se prueba con números.
//
// DOS LISTONES, Y CADA UNO EN SU SITIO. Los dos documentos piden cosas distintas y no se
// pisan si se leen bien:
//
//   · 10-09, «Los seis letreros» (Jesús): la línea nombra «el primero de los dos que no haya
//     cruzado EL 80 %». Su maqueta del momento 2 lo enseña: con la proteína en 38,4 de 48
//     -- el 80 % justo, y aún le faltan 9,6 -- la línea ya dice «ahora, lo suyo sería
//     añadir los hidratos».
//
//   · 11-09, punto 3 (Francisco): «el letrero de las preferencias, SOLO cuando proteína e
//     hidratos estén dentro del margen, no al 80 %». Lo soltaba con seis gramos de hidratos
//     por poner y la comida en rojo por pasarse de grasa.
//
// Así que el 80 % manda para PASAR de un macro al siguiente, y el margen manda solo para la
// última línea, la de las preferencias. En medio -- los dos por encima del 80 % pero alguno
// fuera de margen -- se vuelve a nombrar el que falta, que es la regla de fondo de Jesús:
// «la línea tiene que mirar lo que queda de verdad».
//
// El 80 % sigue siendo el de `lib/elOchenta`, que es el mismo que decide si el botón «80»
// se enseña: los dos listones son de verdad dos, pero el del 80 es UNO solo.
import { cruzoElOchenta } from './elOchenta';

export const LETRERO_EMPIEZA = 'Empieza por la proteína';
export const LETRERO_PROTEINA = 'Ahora lo más importante: la proteína';
export const LETRERO_HIDRATOS = 'Ahora, lo suyo sería añadir los hidratos';
export const LETRERO_PREFERENCIAS = 'Ahora termina de cuadrar la comida con tus preferencias';
// La segunda vuelta de la proteína (Jesús, reunión del 25-09).
export const LETRERO_SEGUIMOS = 'Seguimos con las proteínas';

/**
 * `servido` y `objetivo` son `{ P, H, G }` en gramos; `margen`, los 4 g del método.
 *
 * Un objetivo de cero cuenta como cubierto en los dos listones: así una comida sin hidratos
 * nunca oye «añade hidratos».
 *
 * Y el segundo listón mira SOLO lo que falta, no lo que sobra: si la proteína se pasa, el
 * que avisa es el aviso naranja de arriba, y la línea no puede decir «añade proteína».
 */
export const letreroDelPaso = (servido, objetivo, margen = 4) => {
    const srv = { P: 0, H: 0, G: 0, ...(servido || {}) };
    const tgt = { P: 0, H: 0, G: 0, ...(objetivo || {}) };

    // «Empieza» es solo con la comida en blanco: en cuanto hay algo dentro, ya no está
    // empezando, y es su caso de «si cuadra antes el hidrato que la proteína».
    if (!(srv.P > 0) && !(srv.H > 0) && !(srv.G > 0)) return LETRERO_EMPIEZA;

    const seQuedaCorto = (s, t) => t > 0 && (t - s) > margen;
    // LA PROTEÍNA, CON SUS TRES FRASES (Jesús, reunión del 25-09, por escrito):
    //   - «Ahora lo más importante: la proteína» sale cuando hemos completado el 80 % de los
    //     hidratos y nos falta la proteína;
    //   - si ya ha puesto proteína y le sigue faltando, «Seguimos con las proteínas»;
    //   - y si todavía no ha puesto ninguna, la de empezar.
    if (!cruzoElOchenta(srv.P, tgt.P)) {
        if (tgt.H > 0 && cruzoElOchenta(srv.H, tgt.H)) return LETRERO_PROTEINA;
        return srv.P > 0 ? LETRERO_SEGUIMOS : LETRERO_EMPIEZA;
    }
    if (!cruzoElOchenta(srv.H, tgt.H)) return LETRERO_HIDRATOS;
    if (seQuedaCorto(srv.P, tgt.P)) return LETRERO_PROTEINA;
    // PASADO EL 80 % DE LOS HIDRATOS, YA SON LAS PREFERENCIAS (Jesús, 01-10, vídeo de las
    // 22:56: «el momento en el que pase el 80 % de los hidratos ya tiene que poner el mensaje
    // de que terminas de cuadrar con las preferencias»). Aquí había una vuelta a «añadir los
    // hidratos» mientras les faltaran más de 4 g (Francisco, 11-09, punto 3); con los
    // hidratos cruzados las categorías ya son las preferentes y la línea decía otra cosa.
    // Manda lo más reciente.
    // Dice «termina», no «ya casi»: en ese momento le tocan las preferencias pero la comida
    // todavía no cuadra, y «el "ya está" solo lo dice el verde».
    return LETRERO_PREFERENCIAS;
};
